import script from "./BlockInfos.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockInfos.vue?vue&type=script&setup=true&lang=js"

import "./BlockInfos.vue?vue&type=style&index=0&id=744704f0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\33\\Desktop\\2024\\block-explorer-ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-744704f0"]])

export default __exports__